module.exports = __webpack_public_path__ + "static/media/survey-card.b2d67166.png";